module.exports = __webpack_public_path__ + "img/20230803094304534le8.39e02770.jpg";